import CommentEdit from './CommentEdit'

export default CommentEdit
// eslint-disable-next-line import/export
export * from './CommentEdit'
